var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThumbUp = function SvgThumbUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.301 10.5V20M8.301 10.5l2.336-5.87a1 1 0 0 1 1.282-.566l.639.241A3 3 0 0 1 14.5 7.113V10.5h2.999a2.5 2.5 0 0 1 2.425 3.106l-1.125 4.5A2.5 2.5 0 0 1 16.374 20H5.5A1.5 1.5 0 0 1 4 18.5V12a1.5 1.5 0 0 1 1.5-1.5h2.801Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThumbUp);
export default ForwardRef;